import Sentry from "@similarweb/sentry-logger";

import { tiersConfig } from "app/common/keyword-research/keywords-overview/serpCompositionConsts";
import type { ISerpCompositionGraphItem } from "app/common/keyword-research/keywords-overview/serpCompositionTypes";
import { transformSerpCompositionData } from "../serp-composition/serpCompositionUtils";
import type { SerpMetricRowData } from "app/common/keyword-research/keywords-overview/serpMetricsConsts";
import { transformSerpMetricsData } from "app/common/keyword-research/keywords-overview/serpMetricsUtils";

import { useOverviewStatsData } from "./useOverviewStatsData";

const defaultSerpCompositionData = tiersConfig.map((config) => ({ ...config, y: 0 }));
const defaultSerpMetricData: SerpMetricRowData = {
    organicRowData: { value: null, change: null },
    paidRowData: { value: null, change: null },
    cpcRowData: { value: null, change: null },
};
const defaultAiExistence = 0;

interface IUseSERPData {
    serpCompositionData: ISerpCompositionGraphItem[];
    serpMetricData: SerpMetricRowData;
    aiExistence: number;
    isLoading: boolean;
    error: unknown;
}

export const useSERPData = (): IUseSERPData => {
    const { data, isLoading, error } = useOverviewStatsData();

    const hasValidData = !isLoading && !error && data;

    try {
        const serpCompositionData = hasValidData
            ? transformSerpCompositionData(data.SERPCompositionBreakDown)
            : defaultSerpCompositionData;

        const serpMetricData = hasValidData ? transformSerpMetricsData(data) : defaultSerpMetricData;

        const aiExistence = data?.AioExistence ?? defaultAiExistence;

        return {
            serpCompositionData,
            serpMetricData,
            aiExistence,
            isLoading,
            error,
        };
    } catch (err: unknown) {
        Sentry.errorTracker({
            message: "Error transforming keywords overview intent data",
            e: err,
            level: "error",
        });
        return {
            serpCompositionData: defaultSerpCompositionData,
            serpMetricData: defaultSerpMetricData,
            aiExistence: defaultAiExistence,
            isLoading: false,
            error: err,
        };
    }
};
